<template>
  <div id="gift-card-popup" class="pos-fixed" @click.stop.prevent>
    <div class="overlay" @click.stop.prevent="toggleGiftModal(false, giftContent)"></div>
    <div
      v-if="!isConfirm"
      :style="{
        backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
        height: '290px'
      }"
      class=" padding-10 pos-fixed pos-center-ver pos-center-hor"
      style="margin: auto 5px; z-index: 9999999; border-radius: 10px;"
    >
      <div class="card-name margin-bottom-20" style="font-weight: 700;">
        {{ giftContent.name }}
      </div>
      <div class="fill-in-details" v-if="isGCBuy">
        <div class="text-left margin-bottom-20">
          <div class="receiver-name margin-bottom-10">
            <div style="font-size: 12px; color: #323232;">Receiver's Name*</div>
            <input
              style="outline: none; border: 0; padding: 10px 15px; width: 91%; border-radius: 5px; margin-top: 6px;"
              class="margin-bottom-10"
              type="text"
              v-model="receiverName"
              placeholder="Enter Receiver's Name*"
            />
          </div>
          <div class="receiver-email margin-bottom-10" v-if="showContactNumber(giftContent.name)">
            <div style="font-size: 12px; color: #323232;">
              Receiver's Contact Number*
            </div>
            <input
              style="outline: none; border: 0; padding: 10px 15px; width: 91%;border-radius: 5px; margin-top: 6px;"
              class="margin-bottom-10"
              type="number"
              v-model="receiverEmail"
              placeholder="Enter Receiver's Contact Number*"
            />
          </div>
          <div class="receiver-email margin-bottom-10" v-else>
            <div style="font-size: 12px; color: #323232;">
              Receiver's Email*
            </div>
            <input
              style="outline: none; border: 0; padding: 10px 15px; width: 91%; border-radius: 5px; margin-top: 6px;"
              class="margin-bottom-10"
              type="text"
              v-model="receiverEmail"
              placeholder="Enter Receiver's Email*"
            />
          </div>
          <div class="value-bal align-hor center-ver">
            <div style="color: #323232;" class="w50 align-ver center-hor">
              <div>Value:</div>
              <div class="font-bold">₹{{ giftContent.value }}</div>
            </div>
            <div style="color: #323232;" class="w50 align-ver center-hor">
              <div>Required Balance:</div>
              <div class="font-bold">
                {{ formatReward(giftContent.currency_label, giftContent.currency_req, true) }}
              </div>
            </div>
          </div>
        </div>
        <button
          class=" radius-5 text-uppercase"
          :style="{
            background: isDarkTheme ? buttonBGColor : bgTheme,
            color: isDarkTheme ? headingTextColor : '#ffffff',
            width: '22%',
            padding: '10px',
            border: 'none'
          }"
          @click.stop.prevent="showConfirmation(giftContent)"
        >
          buy
        </button>
      </div>
      <!-- <div
        v-if="true"
        style="background-color: #ffffff; width: 100%; height: 290px; position: relative; bottom: 300px;"
      >
        <div :style="{ backgroundColor: bgTheme, padding: '5px' }">
          <p>Please confirm your email</p>
        </div>
      </div> -->
      <div class="redeemed-details text-semi-small" v-else>
        <img class="w30 margin-bottom-5" :src="giftContent.image_url" />
        <table class="text-left">
          <tbody>
            <tr>
              <td>Date:</td>
              <td class="font-bold">{{ new Date().getDate() }}/{{ new Date().getMonth() }}/{{ new Date().getFullYear() }}</td>
            </tr>
            <tr>
              <td>Ref Number:</td>
              <td class="font-bold">{{ refNum }}</td>
            </tr>
            <tr>
              <td>Name:</td>
              <td class="font-bold">{{ receiverName }}</td>
            </tr>
            <tr>
              <td v-if="showContactNumber(giftContent.name)">
                Contact Number:
              </td>
              <td v-else>Email:</td>
              <td class="font-bold">{{ receiverEmail }}</td>
            </tr>
            <tr>
              <td>Gift Card Value:</td>
              <td class="font-bold">₹{{ giftContent.value }}</td>
            </tr>
            <tr>
              <td>Balance Used:</td>
              <td class="align-hor center-ver font-bold">
                <img class="w-15 margin-right-5" :src="userHeaderBalance.icon" />
                <div>
                  {{ formatReward(giftContent.currency_label, giftContent.currency_req, true) }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      v-if="isConfirm"
      :style="{
        backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
        height: '230px'
      }"
      class=" pos-fixed pos-center-ver pos-center-hor"
      style="margin: auto 5px; z-index: 9999999;"
    >
      <div :style="{ backgroundColor: bgTheme, padding: '18px 5px', color: '#ffffff' }">
        <p style="font-size: 18px; margin: 0px !important;">Please confirm your email</p>
      </div>
      <div style=" padding: 30px 20px 5px 20px;">
        <p style="font-size: 18px; margin: 0px !important;">Please confirm your email {{ receiverEmail }}</p>
      </div>
      <div style=" display: flex; justify-content: center; align-items: center; gap: 20px; padding: 10px; padding-top: 20px;">
        <div
          :style="{
            backgroundColor: bgTheme,
            padding: '10px 20px',
            color: '#ffffff',
            cursor: 'pointer'
          }"
          @click.stop.prevent="buyGiftCard(giftContent)"
        >
          Yes
        </div>
        <div
          :style="{
            backgroundColor: bgTheme,
            padding: '11px 23px',
            color: '#ffffff',
            cursor: 'pointer'
          }"
          @click.stop.prevent="showConfirmationNo()"
        >
          No
        </div>
      </div>
    </div>
    <pan-dialog
      :show="showPanDialog"
      @close="showPanDialog = false"
      @success="onPanValidated()"
    />
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import PanDialog from "@/components/pan-dialog.vue";
export default {
  mixins: [globals],
  components: { "pan-dialog": PanDialog },
  props: {
    model: Object
  },
  data() {
    return {
      receiverName: "",
      receiverEmail: "",
      refNum: "",
      isConfirm: false,
      showPanDialog: false,
      pendingGiftCard: null
    };
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (this.$store.state.sdkEvent && this.$store.state.sdkEvent.isDarkTheme && this.$store.state.sdkEvent.isDarkTheme) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (this.$store.state.sdkEvent && this.$store.state.sdkEvent.themeColors && this.$store.state.sdkEvent.themeColors.shadowBgColor) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    buttonBGColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (this.$store.state.sdkEvent && this.$store.state.sdkEvent.themeColors && this.$store.state.sdkEvent.themeColors.buttonBGColor) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (this.$store.state.sdkEvent && this.$store.state.sdkEvent.themeColors && this.$store.state.sdkEvent.themeColors.headingTextColor) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    }
  },
  methods: {
    showConfirmation(gc) {
      var name = this.receiverName;
      var email = this.receiverEmail;
      var sku = gc.sku;
      var price = gc.value;

      this.isConfirm = false;
      if (!name) {
        this.toastPopup(true, "Please enter the receiver name");
        return false;
      }
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        this.toastPopup(true, "Please enter valid  email");
        return false;
      }

      if (!email) {
        this.toastPopup(true, "Please enter the receiver email");
        return false;
      }

      if (!sku) {
        this.toastPopup(true, "Invalid Gift card!");
        return false;
      }

      if (!price) {
        this.toastPopup(true, "Invalid amount!");
        return false;
      }
      this.isConfirm = !this.isConfirm;
    },
    showConfirmationNo() {
      this.isConfirm = false;
    },
    showContactNumber(name) {
      return name.toLowerCase().includes("paytm");
    },
    validateEmail(email) {
      const EMAILREG = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      if (!EMAILREG.test(email)) {
        this.toastPopup(true, "Please enter a valid Email");
        return false;
      }
    },
    buyGiftCard(gc) {
      var name = this.receiverName;
      var email = this.receiverEmail;
      var sku = gc.sku;
      var price = gc.value;

      this.isConfirm = false;
      if (!name) {
        this.toastPopup(true, "Please enter the receiver name");
        return false;
      }
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        this.toastPopup(true, "Please enter valid  email");
        return false;
      }

      if (!email) {
        this.toastPopup(true, "Please enter the receiver email");
        return false;
      }

      if (!sku) {
        this.toastPopup(true, "Invalid Gift card!");
        return false;
      }

      if (!price) {
        this.toastPopup(true, "Invalid amount!");
        return false;
      }

      this.validateEmail(email);

      var data = {
        name: name,
        email: email,
        sku: sku,
        price: price
      };

      var url = this.$store.getters.flyyDomain + "/buy_gift_cards";
      var headers = this.$store.getters.headers;

      var options = {
        method: "post",
        url: url,
        headers: headers,
        data: data
      };

      axios(options)
        .then(resp => {
          if (resp.status == 200) {
            if (resp.data.success) {
              this.$store.state.giftCardBuy = false;
              this.refNum = resp.data.ref_num;
              this.toastPopup(true, resp.data.message);
            } else if (resp.data.pan_required) {
              this.pendingGiftCard = gc;
              this.showPanDialog = true;
            } else {
              this.toggleGiftModal(false, gc);
              this.toastPopup(true, resp.data.message);
            }
          } else {
            this.toggleGiftModal(false, gc);
            this.toastPopup(true, resp.data.message);
          }
        })
        .catch(err => {
          this.toggleGiftModal(false, gc);
          console.log("Redemption error!");
        });
    },
    onPanValidated() {
      var gc = this.pendingGiftCard;
      this.showPanDialog = false;
      this.pendingGiftCard = null;
      if (gc) {
        this.buyGiftCard(gc);
      }
    }
  },
  created() {
    var trans = this.model;
    if (!this.isEmpty(trans) && !this.isEmpty(trans.gift_card)) {
      var gc = trans.gift_card;
      var tempObj = {};
      tempObj.name = gc.pr_name;
      tempObj.value = gc.amount;
      tempObj.currency_req = trans.value;
      tempObj.currency_label = trans.prize_type;
      tempObj.image_url = gc.pr_image;
      this.receiverName = gc.name;
      this.receiverEmail = gc.email;
      this.refNum = gc.ref_num;
      this.$store.state.gift_content = tempObj;
      this.$store.state.giftCardBuy = false;
    }
  }
};
</script>
